import React from 'react'
import * as Styles from './styles'
import { HERO_BANNER, HERO_BANNER_TITLE, HERO_BANNER_TEXT } from './utils/testIds'

export const HeroBanner: React.FC = () => {
  return (
    <Styles.HeroBackground
      data-test={HERO_BANNER}
      role="region"
      aria-label="Hero Banner Region"
    >
      <Styles.HeroContainer>
        <Styles.HeroTitle data-test={HERO_BANNER_TITLE}>Welcome</Styles.HeroTitle>
        <Styles.HeroText data-test={HERO_BANNER_TEXT}>
          Ready to get started on your paper?
        </Styles.HeroText>
      </Styles.HeroContainer>
    </Styles.HeroBackground>
  )
}

export default HeroBanner
